module.exports = __webpack_public_path__ + "img/background_blue.9896ab87.png";